import React from 'react';
import { Link } from 'gatsby';

export default function StudyMegaMenu({ isShown, close }) {
  return (
    <div className={`mega-menu study-mega-menu ${isShown ? 'active' : ''}`}>
      <div className="tab-content" onMouseLeave={close}>
        <div className="study-menu-content">
          <ul className="study-menu-list">
            <li className="primary">
              <Link to="/books/the-great-controversy">THE GREAT CONTROVERSY</Link>
            </li>

            <li className="secondary">
              <Link to="/timeline/">TIMELINE</Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="overlay" onClick={close}></div>
    </div>
  );
}
